 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CashRegisters":"CashRegisters","Business~Orders~PriceList~Restaraunt":"Business~Orders~PriceList~Restaraunt","Business":"Business","Orders":"Orders","PriceList":"PriceList","Restaraunt":"Restaraunt","Categories":"Categories","Lager":"Lager","Users":"Users","Warehouse":"Warehouse","login":"login","PointsOfSale":"PointsOfSale","error404":"error404"}[chunkId]||chunkId) + "." + {"CashRegisters":"5135ea0c","chunk-3a7ace4c":"4062985e","chunk-77ef7b7b":"3d7eb5c4","chunk-1c1272c8":"f4570d5b","chunk-02d6d755":"b1b2f7bc","chunk-229f43a0":"21b327c8","chunk-2c73454b":"8d993b6f","chunk-2c9a178a":"81cd9153","Business~Orders~PriceList~Restaraunt":"3dd5bd57","Business":"68b5254f","chunk-5be51b24":"9fdfdffd","chunk-68b36820":"a411effd","chunk-bf9bb464":"cca0233f","chunk-d4f8c3ca":"81aec8bf","chunk-fb16f998":"54b1c469","Orders":"21e2d8f9","PriceList":"b305ab29","Restaraunt":"82ee6043","Categories":"7d8c1a60","chunk-056d92b5":"0f9c7592","chunk-14426410":"953319c3","Lager":"0fdfe77b","Users":"5ebe4bc3","Warehouse":"cd5361c4","chunk-72711fcb":"2575b03b","chunk-b0e0ce9c":"9e7c6fe1","login":"ee5bf1cf","chunk-3b89d799":"d595aeb3","PointsOfSale":"2a9341d9","error404":"f888f7a2","chunk-2d216214":"f28c7a60","chunk-2d216257":"1caeb235","chunk-fff0f504":"2b3891c1","chunk-2762eea5":"c2aa59d3","chunk-288d54b2":"1c12331d","chunk-3a879b30":"a348444c","chunk-6b673472":"dee7426a","chunk-8f835524":"d28b8fee","chunk-9ff8841a":"d2743728","chunk-bfa8a1be":"b9fd3f0b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-3a7ace4c":1,"chunk-77ef7b7b":1,"chunk-1c1272c8":1,"chunk-02d6d755":1,"chunk-229f43a0":1,"chunk-2c73454b":1,"Business~Orders~PriceList~Restaraunt":1,"Business":1,"chunk-5be51b24":1,"chunk-68b36820":1,"chunk-bf9bb464":1,"chunk-d4f8c3ca":1,"Orders":1,"PriceList":1,"Restaraunt":1,"Categories":1,"chunk-056d92b5":1,"chunk-14426410":1,"Lager":1,"Users":1,"Warehouse":1,"chunk-72711fcb":1,"chunk-b0e0ce9c":1,"login":1,"chunk-3b89d799":1,"PointsOfSale":1,"error404":1,"chunk-2762eea5":1,"chunk-288d54b2":1,"chunk-3a879b30":1,"chunk-6b673472":1,"chunk-8f835524":1,"chunk-9ff8841a":1,"chunk-bfa8a1be":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CashRegisters":"CashRegisters","Business~Orders~PriceList~Restaraunt":"Business~Orders~PriceList~Restaraunt","Business":"Business","Orders":"Orders","PriceList":"PriceList","Restaraunt":"Restaraunt","Categories":"Categories","Lager":"Lager","Users":"Users","Warehouse":"Warehouse","login":"login","PointsOfSale":"PointsOfSale","error404":"error404"}[chunkId]||chunkId) + "." + {"CashRegisters":"31d6cfe0","chunk-3a7ace4c":"efc9dd8b","chunk-77ef7b7b":"aa31984a","chunk-1c1272c8":"fc2fce6b","chunk-02d6d755":"68297a88","chunk-229f43a0":"405c1c78","chunk-2c73454b":"86a62a70","chunk-2c9a178a":"31d6cfe0","Business~Orders~PriceList~Restaraunt":"0b6f962c","Business":"a9b52790","chunk-5be51b24":"a32e6022","chunk-68b36820":"b8b818a6","chunk-bf9bb464":"405c1c78","chunk-d4f8c3ca":"405c1c78","chunk-fb16f998":"31d6cfe0","Orders":"57eeb778","PriceList":"dfb944c2","Restaraunt":"04e07172","Categories":"4c52c0d0","chunk-056d92b5":"f03b59d1","chunk-14426410":"f03b59d1","Lager":"6385dd28","Users":"56a2e5af","Warehouse":"60a92e50","chunk-72711fcb":"e6a1c3f3","chunk-b0e0ce9c":"8294b832","login":"3c78acad","chunk-3b89d799":"625c13ca","PointsOfSale":"ee0c98c5","error404":"fd8370e9","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-fff0f504":"31d6cfe0","chunk-2762eea5":"98b57428","chunk-288d54b2":"36436cc8","chunk-3a879b30":"5e86c20d","chunk-6b673472":"68a46b1a","chunk-8f835524":"fe1e9d39","chunk-9ff8841a":"684d9ac5","chunk-bfa8a1be":"9f3eb9a5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
